import { fontFamilyBase, fontSizeBase400, fontWeightBold, lineHeightBase400, spacingHorizontalS, spacingVerticalM, spacingVerticalS, display } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
export const styles = css `
  ${display("block")}
  :host {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    overflow: hidden;
    padding: ${spacingVerticalM} ${spacingHorizontalS} ${spacingVerticalS}
      ${spacingHorizontalS};
  }
  .navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: ${spacingVerticalM} 0;
  }
  .header {
    font-size: ${fontSizeBase400};
    font-family: ${fontFamilyBase};
    font-weight: ${fontWeightBold};
    line-height: ${lineHeightBase400};
  }
  .viewport {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    transition: transform 0.3s ease-in-out;
    will-change: transform;
    width: 100%;
    padding-block-start: ${spacingVerticalM};
    padding-inline: 0;
    padding-block-end: ${spacingVerticalS};
  }
  .viewport ::slotted(*) {
    display: inline-block;
    /* Use logical properties for RTL support */
    margin-inline-end: var(--gap-width, 16px);
  }
`;
//# sourceMappingURL=carousel.styles.js.map